class PDPSizeGuideController extends HTMLElement {
  constructor() {
    super();

    this.dataId = null;
    this.sizeGuideBarCloseButton = null;
    this.sizeGuideBarOpenButton = null;
    this.sizeGuideBarDrawer = null;
    this.observerMutation = null;
  }

  connectedCallback() {
    this.dataId = this.getAttribute('data-id');
    const closeButtonId = this.getAttribute('data-close-button-id');
    const openButtonId = this.getAttribute('data-open-button-id');
    const drawerId = this.getAttribute('data-drawer-id');
    this.sizeGuideBarCloseButton = document?.getElementById(closeButtonId);
    this.sizeGuideBarOpenButton = document?.getElementById(openButtonId);
    this.sizeGuideBarDrawer = document?.getElementById(drawerId);

    if (
      !this.sizeGuideBarDrawer ||
      !this.sizeGuideBarCloseButton ||
      !this.sizeGuideBarOpenButton
    ) {
      return null;
    }

    this.initSizeGuide();
  }

  disconnectedCallback() {
    this.handleButtonEvents(true);

    // Clean up observer
    if (this.observerMutation) {
      this.observerMutation.disconnect();
    }
  }

  handleButtonEvents(remove = false) {
    const drawer = this.sizeGuideBarDrawer;
    const closeButton = this.sizeGuideBarCloseButton;
    const openButton = this.sizeGuideBarOpenButton;

    if (!drawer || !closeButton || !openButton) {
      return null;
    }

    if (remove) {
      openButton.removeEventListener('click', () => drawer.open());
      closeButton.removeEventListener('click', () => drawer.close());
    } else {
      openButton.addEventListener('click', () => drawer.open());
      closeButton.addEventListener('click', () => drawer.close());
      this.observeSpecificElement(); // Start observing when added
    }
  }

  initSizeGuide() {
    this.handleButtonEvents();
  }

  observeSpecificElement() {
    // The specific element to target (in this case the open button)
    const targetElement = this.sizeGuideBarOpenButton;

    // Observe the parent node of the target element (in this case, the custom element)
    const parentNode = this;

    // If there's no parent (not yet in DOM), exit early
    if (!parentNode) return null;

    // Options for the observer: only watch childList changes in the parent
    const config = { childList: true };

    // Callback to detect when the specific element is removed
    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.removedNodes.length > 0) {
          mutation.removedNodes.forEach((node) => {
            if (node === targetElement) {
              console.warn('The specific element was removed!');
              // Optionally disconnect observer after removal
              observer.disconnect();
            }
          });
        }
      }
    };

    // Create and start the observer
    const observer = new MutationObserver(callback);
    observer.observe(parentNode, config);

    // Store observer for cleanup
    this.observerMutation = observer;
  }
}

customElements.define('pdp-size-guide-controller', PDPSizeGuideController);
